import { DangerOutline } from '@randstad-lean-mobile-factory/react-components-ui-shared';
import classnames from 'classnames';

import { Base } from '../Base';
import { Props } from '../Base/Base.types';

import styles from './Error.module.scss';

export const Error = ({ children, className }: Props) => (
  <Base
    icon={<DangerOutline className={styles.icon} />}
    className={classnames(styles.info, className)}
  >
    {children}
  </Base>
);
